import { useNavigateTo } from 'hooks/useNavigateTo'

interface UseOpenModalProps {
  videoInfo: any
}

export default function useOpenModal({ videoInfo }: UseOpenModalProps) {
  const { navigateToViewMore, navigateToEnableVip } = useNavigateTo()

  const openEnableVipModal = () => {
    navigateToEnableVip({})
  }

  const openViewMoreModal = () => {
    const params = {
      producer_id: videoInfo.producer_id,
    }

    navigateToViewMore({
      params,
    } as unknown as Parameters<typeof navigateToViewMore>[0])
  }

  return {
    openEnableVipModal,
    openViewMoreModal,
  }
}
